import { MonitorAircraftThreshold, ThresholdLevel } from '../../../../../../../types/thresholds';

export const levelToKeyMap = {
    [ThresholdLevel.info]: 'info',
    [ThresholdLevel.watch]: 'watch',
    [ThresholdLevel.warning]: 'warning',
    [ThresholdLevel.critical]: 'critical',
    [ThresholdLevel.emergency]: 'emergency'
} satisfies Record<ThresholdLevel, keyof MonitorAircraftThreshold>;
